// import TimEventBus from '../TimEventBus'
import { getAnswerQuesInfoById } from '../../../api/livingRoom'
export default {
  namespaced: true,
  state: {
    // 已参与答题列表,只存储id
    hasJoinAnswerQuesList: [],
    // 当前接收到的答题
    currentReceivedQuestion: {},
    // 选择的选项
    selectOptionsIndex: [],
    // 是否达对
    isAnswerRight: ''
  },
  mutations: {
    commit_setCurrentReceivedQuestion(state, payload) {
      state.currentReceivedQuestion = payload
    },
    commit_setHasJoinAnswerQuesList(state, payload) {
      state.hasJoinAnswerQuesList.push(payload)
    },
    commit_setSelectOptionsIndex(state, payload) {
      state.selectOptionsIndex = payload
    },
    commit_setIsAnswerRight(state, payload) {
      state.isAnswerRight = payload
    },
    commit_clearStore(state, payload) {
      state.isAnswerRight = ''
      state.selectOptionsIndex = []
      state.currentReceivedQuestion = []
    }
  },
  actions: {
    dispatch_TIMEVENT_startQuestionBank({ state, commit }, message) {
      console.log(message)
      const { quoteId } = message
      commit('commit_clearStore')
      commit('commit_setHasJoinAnswerQuesList', quoteId)
      getAnswerQuesInfoById(quoteId).then((res) => {
        commit('commit_setCurrentReceivedQuestion', res.data.data)
      })
    },
    dispatch_TIMEVENT_endQuestionBank({ state }, message) {
      console.log(message)
    }
  }
}
